import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getUserByInvitationToken, UserInvitationResponse } from 'services/api/auth-api.service';
import { TriggerTypeEnum } from 'common/enums/trigger-type.enum';

export interface RegistrationToken extends UserInvitationResponse {
    // This interface now extends the one from auth-api.service.ts
    // All fields are inherited from UserInvitationResponse
}

interface UseUserByInvitationTokenOptions {
    onSuccess?: (data: RegistrationToken | null) => void;
}

export const useUserByInvitationToken = (token?: string, options?: Omit<UseQueryOptions<RegistrationToken | null, Error>, 'queryKey' | 'queryFn' | 'enabled'>) => {
    console.log('useUserByInvitationToken called with token:', token);
    
    return useQuery<RegistrationToken | null, Error>({
        queryKey: ['user-by-invitation-token', token],
        queryFn: async () => {
            if (!token) {
                return null;
            }
            try {
                const result = await getUserByInvitationToken(token);
                return result;
            } catch (error) {
                throw error;
            }
        },
        ...options,
        enabled: !!token,
        retry: 1,
        staleTime: 5 * 60 * 1000 // 5 minutes
    });
};
